export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const FETCH_USER_DATA_FAIL = "FETCH_USER_DATA_FAIL";
export const SAVE_WISHLISH = "SAVE_WISHLISH";
export const FETCH_WISHLIST_DATA = "FETCH_WISHLIST_DATA";
export const FETCH_WISHLIST_FAIL = "FETCH_WISHLIST_FAIL";
